var map = {
	"./camera-black.svg": 455,
	"./camera.svg": 456,
	"./clock-face.svg": 1008,
	"./cross-red.svg": 251,
	"./dots-top-right.png": 446,
	"./dustbin-red.svg": 457,
	"./exclamation-mark-red.svg": 252,
	"./face-happy-filled.svg": 1009,
	"./face-happy.svg": 1010,
	"./face-recognition.svg": 458,
	"./face-sad-filled.svg": 459,
	"./face-sad.svg": 460,
	"./face-smile-filled.svg": 461,
	"./face-smile.svg": 462,
	"./face-unsure-filled.svg": 463,
	"./face-unsure.svg": 464,
	"./folder.svg": 454,
	"./great-clean-logo.png": 1011,
	"./heartbeat.svg": 450,
	"./iAuditor-icon.svg": 119,
	"./logo.svg": 447,
	"./message.svg": 453,
	"./mortar-board.svg": 449,
	"./peabody-logo.png": 1012,
	"./rectangular-blobs.svg": 448,
	"./sort_down_icon.svg": 56,
	"./sort_up_icon.svg": 57,
	"./speech-bubbles.svg": 451,
	"./tick-blue.svg": 465,
	"./tick-green.svg": 466,
	"./tick-on-shield.svg": 253,
	"./user.svg": 452,
	"./wetton-logo.jpeg": 250,
	"./wetton-logo.png": 1013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1007;